module.exports = __webpack_public_path__ + "img/image_black_24dp.ca89d30b.svg";